import { ReactNode } from 'react';
import { useEvaluatedFlowAttributesContent } from 'core/flow/hooks';
import { PaymentError as PaymentFormError, PaymentErrorCode } from 'core/payments/entities';
import { PaymentError } from './PaymentError';
import { PaymentErrorProcessing } from './PaymentErrorProcessing';

type PaymentFormFailedProps = {
  onTryAgain: () => void;
  paymentError: PaymentFormError | null;
  expressButton?: ReactNode;
};

export const PaymentFormFailed = ({
  paymentError,
  onTryAgain,
  expressButton,
}: PaymentFormFailedProps) => {
  const content = useEvaluatedFlowAttributesContent();

  if (!paymentError || !paymentError.code || !content.payments?.errors) {
    return <PaymentErrorProcessing onTryAgain={onTryAgain} expressButton={expressButton} />;
  }

  const paymentErrorContent =
    content.payments.errors[paymentError.code] ??
    content.payments.errors[PaymentErrorCode.GENERAL_DECLINE];

  if (!paymentErrorContent) {
    return <PaymentErrorProcessing onTryAgain={onTryAgain} expressButton={expressButton} />;
  }

  return (
    <PaymentError
      content={paymentErrorContent}
      onTryAgain={onTryAgain}
      expressButton={expressButton}
    />
  );
};
